export type EposRetailer = "1" | "3";

export const eposRetailerStorageKey = "abakus.epos.retailer";

export const getSavedEposRetailer = (): EposRetailer => {
    const savedRetailer = localStorage.getItem(eposRetailerStorageKey);
    return savedRetailer === "3" ? "3" : "1";
};

export const saveEposRetailer = (retailer: string): EposRetailer => {
    const selectedRetailer: EposRetailer = retailer === "3" ? "3" : "1";
    localStorage.setItem(eposRetailerStorageKey, selectedRetailer);
    return selectedRetailer;
};
